import { render } from "./ColorsComponent.vue?vue&type=template&id=401017e5"
import script from "./ColorsComponent.vue?vue&type=script&lang=js"
export * from "./ColorsComponent.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__